import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";
import toSeoUrl from "@functions/toSeoUrl";

const fetchFeatureFilms = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/media/feature-films/${subscriberGroupId}`);
    const filmList = res.data?.data?.feature_films || [];
    filmList.forEach((film) => {
        film.feature_url = film.feature_film_flag
            ? `${film.ad_category_url}/${film.bo_movie_id}/${toSeoUrl(film.bo_movie_title ?? "")}`
            : film.ad_category_url;
        film.trailer_url = film.trailer_available ? film.trailer_url : "";
    });

    return filmList;
};

export const useFeatureFilms = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["featureFilms", subscriberGroupId],
        queryFn: () => fetchFeatureFilms(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        featureFilm: data ?? null,
        isLoadingFeatureFilms: isLoading,
    };
};
